import {
  Button,
  Form,
  Layout,
  Space,
  Spin,
  Steps,
  Typography,
  message
} from "antd";
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import APIService from "../Api/api.service";
import Document from "../components/3rpartyrequest/singlerequest/documents";
import PatientInformation from "../components/3rpartyrequest/singlerequest/patientinformation";
import RecordRelease from "../components/3rpartyrequest/singlerequest/recordrelease";
import Requester from "../components/3rpartyrequest/singlerequest/requester";
import Facility from "../components/3rpartyrequest/singlerequest/facility";
import { ThemeContext } from "../context/themeContext";
import { dataDate } from "../components/dateValidator";
import CustomHeader from "../components/common/Header";

const FormItemLayout = {
  labelCol: {
    xl: {
      span: 24,
    },
  },
  wrapperCol: {
    xl: {
      span: 24,
    },
  },
};

const SingleRequest = (props) => {
  const { theme } = useContext(ThemeContext)
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate(); // Hook for navigation
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { Content, Footer, Header } = Layout;
  const [apiservice] = useState(() => new APIService());
  const [defaultFile, setDefaultFile] = useState({})

  const [singleRequestData, setsingleRequestData] = useState({
    PatientFirstName: "",
    PatientLastName: "",
    PatientEmail: "",
    PatientDOB: "",
    RequesterName: "",
    RequesterLastName: "",
    RequesterFaxNumber: "",
    RequesterPhoneNumber: "",
    useRequesterInformation: "",
    RequesterEmail: "",
    RequesterAddLine1: "",
    RequesterAddLine2: "",
    RequesterCity: "",
    RequesterState: "",
    RequesterZipCode: "",
    RecordMethod: "",
    RecordMethodReleaseName: "",
    RecordMethodReleaseEmail: "",
    RecordMethodReleaseFaxNumber: "",
    RecordName: "",
    RecordPhoneNumber: "",
    RecordEmail: "",
    RecordFaxNumber: "",
    AuthorizationDocument: [],
    AdditionalDocuments: [],
    DocumentNotes: "",
    SRFacilityName: "",
    SRFacility_Email: "",
    SRFacilityPhoneNumber: "",
    SRFacilityAddressLine1: "",
    SRFacilityAddressLine2: "",
    SRFacilityCity: "",
    SRFacilityState: "",
    SRFacilityZipCode: "",
    SRFacilityType: "",
  });

  const getChildData = (value, name) => {
    let res = { ...singleRequestData, [name]: value };
    setsingleRequestData(res);
  };
  const onsubmit = async () => {
    form
      .validateFields()
      .then(async () => {
        setLoading(true);
        const ThirdPartySingleRequestModel = {
          patientInformation: {
            firstName: singleRequestData.PatientFirstName.toString(),
            lastName: singleRequestData.PatientLastName.toString(),
            Email: singleRequestData.PatientEmail.toString(),
            // dateOfBirth: singleRequestData.PatientDOB,
            dateOfBirth: dataDate(singleRequestData.PatientDOB),
          },
          requesterDetails: {
            requesterName: singleRequestData.RequesterName.toString(),
            requesterLastName: singleRequestData.RequesterLastName.toString(),
            requesterPhoneNumber: singleRequestData.RequesterPhoneNumber.toString(),
            requesterEmail: singleRequestData.RequesterEmail.toString(),
            requesterFaxNumber: singleRequestData.RequesterFaxNumber.toString(),
            requesterAddressLine1: singleRequestData.RequesterAddLine1.toString(),
            requesterAddressLine2: singleRequestData.RequesterAddLine2.toString(),
            requesterCity: singleRequestData.RequesterCity.toString(),
            requesterState: singleRequestData.RequesterState.toString(),
            requesterZipCode: singleRequestData.RequesterZipCode.toString(),
          },
          recordReleaseInformation: {
            methodOfRelease: singleRequestData.RecordMethod.toString(),
            RecordMethodReleaseName: singleRequestData.RecordMethodReleaseName.toString(),
            RecordMethodReleaseEmail: singleRequestData.RecordMethodReleaseEmail.toString(),
            recordMethodReleaseFaxNumber: singleRequestData.RecordMethodReleaseFaxNumber.toString() != "" ? singleRequestData.RecordMethodReleaseFaxNumber.toString() : singleRequestData.RecordMethod.toString().toLowerCase() == "fax" ? singleRequestData.RequesterFaxNumber.toString() : "",
            useRequesterInformation: singleRequestData.useRequesterInformation,
            nameOrganization: form.getFieldValue("rnameorganization").toString(),//singleRequestData.RecordName.toString()!=""?singleRequestData.RecordName.toString():singleRequestData.RequesterName.toString(),
            phoneNumber: form.getFieldValue("rphone").toString(),//singleRequestData.RecordPhoneNumber.toString()!=""?singleRequestData.RecordPhoneNumber.toString():singleRequestData.RequesterPhoneNumber.toString(),
            email: form.getFieldValue("remail").toString(),//singleRequestData.RecordEmail.toString()!=""?singleRequestData.RecordEmail.toString():singleRequestData.RequesterEmail.toString(),
            fax: form.getFieldValue("rfax").toString(),//singleRequestData.RecordFaxNumber.toString(),
          },
          documentUpload: {
            releaseAutorizationDocument: singleRequestData.AuthorizationDocument,
            additionalDocuments: singleRequestData.AdditionalDocuments,
            additionalNotes: singleRequestData.DocumentNotes.toString(),
          },
          facilityInformation: {
            FacilityType: singleRequestData.SRFacilityType.toString(),
            FacilityName: form.getFieldValue("SRfacilityname").toString(),
            Facility_Email: singleRequestData.SRFacility_Email.toString(),//form.getFieldValue("Facility_Email") != "undefined" ? form.getFieldValue("Facility_Email").toString() : "",
            FacilityPhoneNumber: singleRequestData.SRFacilityPhoneNumber.toString(),//form.getFieldValue("fphone") != "undefined" ? form.getFieldValue("fphone").toString() : "",
            FacilityAddressLine1: singleRequestData.SRFacilityAddressLine1.toString(),//form.getFieldValue("faddress1").toString(),
            FacilityAddressLine2: singleRequestData.SRFacilityAddressLine2.toString(),//form.getFieldValue("faddress2") != "undefined" ? form.getFieldValue("faddress2").toString() : "",
            FacilityCity: form.getFieldValue("SRfcity").toString(),
            FacilityState: form.getFieldValue("SRfstate").toString(),
            FacilityZipCode: form.getFieldValue("SRfzipcode").toString(),
            Facility_StartDate: null,
            Facility_EndDate: null,
          },
          Token: sessionStorage.getItem("secrateKey"),
          ClientName: sessionStorage.getItem("currentActiveClient")
        };
        if (sessionStorage.getItem("secrateKey") != null) {
          let result = await apiservice.postRequest(
            "SavePatientDetails/ThridPatrySingleRequest",
            ThirdPartySingleRequestModel
          );
          if (result.status !== null) {
            if (result == "SUCCESS") {
              setLoading(false);
              navigate("/Thanks");
            }
            else if (result == "Failed") {
              setLoading(false);
              message.error(`Something went wrong, please try again!`);
            }
          }
        }
        else {
          setLoading(false);
          message.error(`Something went wrong, please try again!`);
        }
      })
      .catch((info) => {
        setLoading(false);
      });
  };
  const steps = [
    {
      title: "Patient",
    },
    {
      title: "Requester",
    },
    {
      title: "Facility",
    },
    {
      title: "Recipient",
    },
    {
      title: "Documents",
    },
  ];
  const next = () => {
    form
      .validateFields()
      .then(() => {
        setCurrent(current + 1);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };
  const prev = () => {
    setCurrent(current - 1);
  };
  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));
  const onFinish = (values) => {
    navigate("/Thanks");
  };
  return (
    <Spin spinning={loading}>
      <Layout className="bg-white">
       <CustomHeader />
        <Content className="p-8">
          <div className="container mx-auto">
            <Steps
              className={theme}
              type="default"
              labelPlacement={"vertical"}
              current={current}
              items={items}
            />
            {current === 0 && (
              <Form
                layout="vertical"
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step1"
              >
                <PatientInformation form={form} getChildData={getChildData} />
              </Form>
            )}
            {current === 1 && (
              <Form
                layout="vertical"
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step2"
              >
                <Requester form={form} getChildData={getChildData} />
              </Form>
            )}
            {current === 2 && (
              <Form
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step3"
                layout="vertical"
              >
                <Facility form={form} getChildData={getChildData} />
              </Form>
            )}
            {current === 3 && (
              <Form
                layout="vertical"
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step4"
              >
                <RecordRelease form={form} getChildData={getChildData} singleRequestData={singleRequestData} />
              </Form>
            )}
            {current === 4 && (
              <Form
                layout="vertical"
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step5"
              >
                <Document getChildData={getChildData} form={form} defaultFile={defaultFile} setDefaultFile={setDefaultFile} />
              </Form>
            )}
            <Space className="mt-8 w-full justify-between">
              {current > 0 && (
                <Button
                  type="primary"


                  onClick={() => prev()}
                >
                  Back
                </Button>
              )}
              {current === steps.length - 1 && (
                <Button
                  type="primary"


                  onClick={current === 4 ? onsubmit : next}
                >
                  Submit
                </Button>
              )}
              {!current && (
                <Link to="/Partyrequest">
                  <Button type="primary" >
                    Back
                  </Button>
                </Link>
              )}
              {current < steps.length - 1 && (
                <Button
                  type="primary"


                  onClick={() => next()}
                >
                  Next
                </Button>
              )}
            </Space>
          </div>
        </Content>
        <Footer className="welcome-footer bg-white">
          <img
            className="m-auto"
            src={window.location.origin + "/assets/images/Logo.png"}
          />
        </Footer>
      </Layout>
    </Spin>
  );
};

export default SingleRequest;
